import {
  type CopilotDefinition,
  FRESHSERVICE_SESSION_COOKIE_NAME,
} from "./types";

export const FRESHSERVICE_SURFACE = "freshservice-copilot" as const;

/**
 * The Freshservice side-panel copilot — Magnus running inside a cross-site
 * iframe hosted by a Freshservice FDK app (`apps/freshservice-copilot`).
 * Ticket context (id, subject, requester email, agent flag) arrives as URL
 * params on the `/freshservice/panel` bootstrap page. No postMessage handshake.
 */
export const freshserviceCopilot: CopilotDefinition = {
  copilotId: "freshservice",
  displayName: "Freshservice",
  surfaceLabel: "Freshservice side panel",
  surfaces: [FRESHSERVICE_SURFACE],
  capabilities: ["freshservice"],
  embedded: {
    [FRESHSERVICE_SURFACE]: {
      // Cross-site iframe: the Better-Auth cookie (SameSite=Lax) never rides
      // requests from inside the Freshservice frame, so the panel carries its
      // own bearer (sessionStorage) + `SameSite=None; Secure` cookie, minted
      // by `/api/auth/freshservice-session` — same pattern as Procore.
      sessionStorageKey: FRESHSERVICE_SESSION_COOKIE_NAME,
      sessionCookieName: FRESHSERVICE_SESSION_COOKIE_NAME,
      framedOnly: true,
      capturesContext: true,
    },
  },
};
